module.exports = __webpack_public_path__ + "media/images/icon__form--checkmark@3x-71112bdd641ec0ce8eedff3b52240c91.png";